"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TextVerticalSpacer_1 = __importDefault(require("../../utils/TextVerticalSpacer"));
var typography_1 = require("../../typography");
var Img_1 = __importDefault(require("../../misc/Images/Img/Img"));
var Link_1 = __importDefault(require("../../navigation/Link"));
var TopicTags_1 = __importDefault(require("../TopicTags/TopicTags"));
var VerticalSpacer_1 = __importDefault(require("../../utils/VerticalSpacer"));
var styles_1 = require("./styles");
var VS_1 = { small: 16, medium: 16, large: 24 };
var LibraryPostBlock = function (_a) {
    var topics = _a.topics, title = _a.title, link = _a.link, description = _a.description, image = _a.image, type = _a.type, children = _a.children, commonProps = __rest(_a, ["topics", "title", "link", "description", "image", "type", "children"]);
    var _b = __read(react_1.useState(false), 2), hovered = _b[0], setHovered = _b[1];
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "LibraryPostBlock" }, commonProps),
        react_1.default.createElement(styles_1.Content, null,
            react_1.default.createElement(VerticalSpacer_1.default, { amount: VS_1 },
                react_1.default.createElement(Link_1.default, __assign({}, link, { color: "GREY_90", hoverColor: "BLUE_50", ariaLabel: "View " + title, block: true }),
                    react_1.default.createElement(TextVerticalSpacer_1.default, { level: "3" },
                        react_1.default.createElement(typography_1.Label, { color: "GREY_70", level: "1" }, type),
                        react_1.default.createElement(typography_1.Heading, { level: "3", color: hovered ? 'BLUE_50' : undefined }, title),
                        react_1.default.createElement(typography_1.Body, { level: "4", color: "GREY_90" }, description))),
                topics && react_1.default.createElement(TopicTags_1.default, null, topics))),
        react_1.default.createElement(styles_1.ImageWrapper, __assign({}, link, { color: "GREY_90", hoverColor: "BLUE_50", ariaLabel: "View " + title, block: true, onMouseEnter: function () { return setHovered(true); }, onMouseLeave: function () { return setHovered(false); } }),
            react_1.default.createElement(Img_1.default, __assign({}, image, { aspectRatio: "1:1", fit: "cover", isRounded: true, alt: image.alt || '' })),
            children)));
};
exports.default = LibraryPostBlock;
